const iqac=[
    {
       sno:'1',
       rep:'Chair Person\n(Ex- Officio)',
       name:'Dr.K.Baskaran\nPrincipal'
    },
    {
        sno:'2',
        rep:'Coordinator',
        name:'Dr.G.Renisha\nASP/ECE'
    },
    {
        sno:'3',
        rep:'Co-coordinator',
        name:'Prof.S.Syed Suhaia,\nAP/CSE'
    },
    {
        sno:'4',
        rep:'Co-coordinator',
        name:'Dr.R.N.Mariammal,\nAP/Physics'
    },
    {
        sno:'5',
        rep:'Faculty',
        name:'Dr.A.Sivanantharaja,\nProfessor/ECE and NAAC Coordinator'
    },
    {
        sno:'6',
        rep:'Faculty',
        name:'Dr.K.Ramanathan,\nProfessor/ Mechanical Engineering'
    },
    {
        sno:'7',
        rep:'Faculty',
        name:'Dr.C.Subramanian,\nProfessor/Civil Engineering'
    },
    {
        sno:'8',
        rep:'Faculty',
        name:'Dr.A.Arunya Revathy,\nProfessor/EEE'
    },
    {
        sno:'9',
        rep:'Faculty',
        name:'Dr.C.Umarani,\nASP/CSE'
    },
    {
        sno:'10',
        rep:'Faculty',
        name:'Dr.S.Ponmudi,\nASP/Physics'
    },
    {
        sno:'11',
        rep:'Faculty',
        name:' Dr.C.Vijayaprabha,\nASP/Civil and NBA Coordinator'
    },
    {
        sno:'12',
        rep:'Administration',
        name:'Mrs.S.Manohari,\nPA to Principal'
    },
    {
        sno:'13',
        rep:'Alumni',
        name:'Dr.G.Sozhan,\nChief Scientist(Rtd),CSIR-CECRI'
    },
    {
        sno:'14',
        rep:'Students',
        name:'Ms.S.Swetha,(Reg.No. 91762115041)\nIII year (CSE)'
    },
    {
        sno:'15',
        rep:'Students',
        name:'Mr.S.Barath Raj,(Reg.No. 91762211010)\nII year (Civil)'
    },
    {
        sno:'16',
        rep:'Society',
        name:'Mr.A.R.Narayanan,\nBusiness man,\nKaraikudi'
    },
    {
        sno:'17',
        rep:'Employer',
        name:'Dr.R.Vijaya Rajeshwaran\nVI Microsystems,Pvt.Ltd'
    },
    {
        sno:'18',
        rep:'Industrialist',
        name:'Dr.R.Kalidoss\nManaging Director, Protech Anodes & Alloy Engineers, SIDCO Industrial Estates\nKaraikudi'
    },
    {
        sno:'19',
        rep:'Stake Holders',
        name:'Mrs.T.Kalaivani,\nParent,HOD/IT,Sri Sai Niketan College for Women\nAmaravathipudur'
    }
]

const iqac_func= [
    {
      id: "1",
      point:
        "Development and application of quality benchmarks.",
    },
    {
        id: "2",
        point:
          "Parameters for various academic and administrative activities of the institution.",
    },
    {
        id: "3",
        point:
          "Facilitating the creation of a learner-centric environment conducive to quality education and faculty maturation to adopt the required knowledge and technology for participatory teaching and learning process.",
    },
    {
        id: "4",
        point:
          "Collection and analysis of feedback from all stakeholders on quality-related institutional processes.",
    },
    {
        id: "5",
        point:
          "Dissemination of information on various quality parameters to all stakeholders.",
    },
    {
        id: "6",
        point:
          "Organization of inter and intra institutional workshops, seminars on quality related themes and promotion of quality circles.",
    },
    {
        id: "7",
        point:
          "Documentation of the various programmes/activities leading to quality improvement.",
    },
    {
        id: "8",
        point:
          "Acting as a nodal agency of the Institution for coordinating quality-related activities, including adoption and dissemination of best practices.",
    },
    {
        id: "9",
        point:
          "Development and maintenance of institutional database through MIS for the purpose of maintaining /enhancing the institutional quality.",
    },
    {
        id: "10",
        point:
          "Conducting programmes to promoe the usage of renewable energy sources.",
    },
    {
        id: "11",
        point:
          "Developing Entrepreneurial culture among the students and sharing the available infrastructure for creating new incubators.",
    },
    {
        id: "12",
        point:
          "Periodical conduct of Academic and Administrative Audit and its follow-up.",
    },
    {
        id: "13",
        point:
          "Conducting topographic specific skill development programmes to the skilled and unskilled persons of the society.",
    },
    {
        id: "14",
        point:
          "Preparation and submission of the Annual Quality Assurance Report (AQAR) as per guidelines and parameters of NAAC within 31st December of every year.",
    }
]

const iqac_aim=
    {
       id:'1',
       visionhead:'Aim',
       visiondata:'To develop a system for conscious, consistent and catalytic action to improve the academic and administrative performance of the institution.To promote measures for institutional functioning towards quality enhancement through internalization of quality culture and institutionalization of best practices.To keep track on the implementation of the Vision and Mission of the institution.'

    }
const iqac_strategy=[
    {
        id:'1',
        mission:'Ensuring timely, efficient and progressive performance of academic, administrative and financial tasks.'
    },
    {
        id:'2',
        mission:'Relevant and quality academic/ research programmes.'
    },
    {
        id:'3',
        mission:' Equitable access to and affordability of academic programmes for various sections of society.'
    },
    {
        id:'4',
        mission:'Optimization and integration of modern methods of teaching and learning.'
    },
    {
        id:'5',
        mission:'The credibility of assessment and evaluation process.'
    },
    {
        id:'6',
        mission:'Ensuring the adequacy, maintenance and proper allocation of support structure and services.'
    },
    {
        id:'7',
        mission:'Sharing of research findings and networking with other institutions in India and abroad.'
    },
]

const iqac_feed=[
    {
        'id':"1",
        "head":"2023-2024",
        "house":"right",
        "pdf":"/Feedback Analysis_23-24.pdf"
    },
    {
        'id':"1",
        "head":"2022-2023",
        "house":"left",
        "pdf":"/feedback_analysis_22-23.pdf"
    },
    {
        'id':"2",
        "head":"2021-2022",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1L8makTfisdAAXqetJve4xyCbbtWp1SKg/view?usp=sharing"
    },
    {
        'id':"3",
        "head":"2020-2021",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1U7selJmYywgb7CTOxTtTG3xtvri6sLvn/view?usp=sharing"
    },
]

const iqac_blocks=[
    {
        'id':"1",
        "head":"2024-2025",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1b1pLUSi1fI9LqutkWGrDoS--mHZ_WM7c/view?usp=sharing"
    },
    {
        'id':"1",
        "head":"2023-2024",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1UxQnRE6CDTf4h3F0AZ1r2fc-4DH_Xghp/view?usp=sharing"
    },
    {
        'id':"2",
        "head":"2022-2023",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1Zj_vDK5FwNIVnanLPQviXWDZzJzvWfWZ/view?usp=sharing"
    },
    {
        'id':"3",
        "head":"2021-2022",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1eNPRMDKYZLCd57Q9TVxSBuf4BVRJJuBn/view?usp=sharing"
    },
]

const iqac_aqar=[
   {
    'id': "5",
    "head":"2023-2024",
    "house":"left",
    "pdf":"/AQAR_2023-24.pdf"
    },
    {
        'id':"4",
        "head":"2022-2023",
        "house":"right",
        "pdf":"/AQAR_2022-23.pdf"
    },
    {
        'id':"3",
        "head":"2021-2022",
        "house":"left",
        "pdf":"/AQAR_report_2021-22.pdf"
    },
    {
        'id':"2",
        "head":"2020-2021",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1hSrjWRvgKoAXN_KciLxrVJ43vfeQOba1/view?usp=sharing"
    },
    {
        'id':"1",
        "head":"2019-2020",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1hMUs4sZ5zs31hzs98AvB7_sYxFrjMs3_/view?usp=sharing"
    }
]

const iqac_min=[
    {
        'id':"1",
        "head":"2023-2024",
        "house":"right",
        "pdf":"/IQAC_minutes_2023_24.pdf"
    },
    {
        'id':"2",
        "head":"2022-2023",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1yVLm5uboQNFRn7hbdfQkDCy8xv107oTE/view?usp=sharing"
    },
    {
        'id':"3",
        "head":"2021-2022",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1Zm5pXNd18iL-msALg8QaEgXZaLfAuE8J/view?usp=sharing"
    },
    {
        'id':"4",
        "head":"2019-2020",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1hh5q6FFtUblw5qhRJ9D7b0WNpqOaeLxb/view?usp=sharing"
    },

    
]

const iqac_floater_menu={
    'head':'IQAC',
    'links':[
        {
            'id':'5',
            'link':'Overview',
            'path':'/iqac'
        },
        {
            'id':'1',
            'link':'IQAC Minutes',
            'path':'/iqac_min'
        },
     
        {
            'id':'2',
            'link':'AQAR Report',
            'path':'/iqac_aqar'
        },
        {
            'id':'3',
            'link':'Feedback Reports',
            'path':'/iqac_feed'
        },
        {
            'id':'4',
            'link':'IQAC Cell',
            'path':'https://drive.google.com/file/d/1lSZrWnGYEd6P9qNV8oVT2axqGA4JSdu2/view?usp=sharing'
        },
        {
            'id':'6',
            'link':'Best Practices of the Institute',
            'path':'/iqac_practices'
        },
        {
            'id':'6',
            'link':'Institutional Distinctiveness',
            'path':'/iqac_distinctiveness'
        },
        {
            'id':'7',
            'link':'Strategic Plan',
            'path':'/iqac_strategic'
        },
        {
            'id':'8',
            'link':'Student Satisfaction Survey',
            'path':'/iqac_std_statisfy'
        },
        {
            'id':'9',
            'link':'Committee',
            'path':'/iqac_committee'
        },
        {
            'id':'10',
            'link':'Programmes Organized',
            'path':'/iqac_programmes'
        },
        {
            'id':'11',
            'link':'Block Grant Audit Statements',
            'path':'/iqac_blocks'
        },
    ]
}
const distinctiveness_data=[
    {
        'id':'1',
        'program':'Institutional Distinctiveness',
        'pdf':'/Institutional_distinctiveness.pdf'
      },
]

const iqac_com=[
    {
        'id':'1',
        'program':'போதை பொருள் தடுப்பு குழு',
        'pdf':'https://drive.google.com/file/d/1ZH4Gn3P9C8z7fWLG-lpMMiwb69xf1s0F/view?usp=sharing'
    },
    {
        'id':'2',
        'program':'Students grievance redressal committee',
        'pdf':'https://drive.google.com/file/d/1dBxKqzTO4ni0xzPT7s7dqq86UT5q11KZ/view?usp=sharing'
    },
    {
        'id':'3',
        'program':'Research Advisory committee',
        'pdf':'https://drive.google.com/file/d/1-Nj0WnGQYAjkBbNu5_rO3o4thglf5rN0/view?usp=sharing'
    },
    {
        'id':'4',
        'program':'Placement advisory committee',
        'pdf':'https://drive.google.com/file/d/1eOQfzS1EfQwXb2fLK1s1JCNeHEkUIUyn/view?usp=sharing'
    },
    {
        'id':'5',
        'program':'Library committee',
        'pdf':'https://drive.google.com/file/d/1TKHa-9nyg6hjXvz111vCkf1BYGN36ure/view?usp=sharing'
    },
    {
        'id':'6',
        'program':'Internal committee ',
        'pdf':'https://drive.google.com/file/d/1xUPFa0h9XPOZ6vadVi8QzdeXh0PA9yZA/view?usp=sharing'
    },
    {
        'id':'7',
        'program':'Hostel committee',
        'pdf':'https://drive.google.com/file/d/1gVEfbqewbHAjckku2KYutYDDtH7QoISB/view?usp=sharing'
    },
    {
        'id':'8',
        'program':'Grievance redressal committee',
        'pdf':'https://drive.google.com/file/d/1BwRJ5LHg-VuHmdM-62iOcbTS9iBCIabl/view?usp=sharing'
    },
    {
        'id':'9',
        'program':'Examination reform committee',
        'pdf':'https://drive.google.com/file/d/1BgUmw4mI-urL_3plHEoBGX8VCHXC1SbU/view?usp=sharing'
    },
    {
        'id':'10',
        'program':'Differently abled persons welfare committee',
        'pdf':'https://drive.google.com/file/d/1-2F-hErRd6EGIS9qHgyBDs7gi0qa9gUc/view?usp=drive_link'
    },
    {
        'id':'11',
        'program':'Committee for SC-ST',
        'pdf':'https://drive.google.com/file/d/1GhaZQgLZCNORnBemF4pMAH002id3RfrJ/view?usp=sharing'
    },
    {
        'id':'12',
        'program':'Co curricular-Extra curricular activities committee',
        'pdf':'https://drive.google.com/file/d/1bszhAa8wYJzLYbarkZ4BECoQmP0GibBu/view?usp=sharing'
    },
    {
        'id':'13',
        'program':'Anti ragging committee',
        'pdf':'https://drive.google.com/file/d/1nHKTUtFQEqas_hsNODkyQg5yh6CWaA1H/view?usp=drive_link'
    },
]

const Strategic_data=[
    {
        'id':'1',
        'program':'Strategic Plan',
        'pdf':'/strategic_plan.pdf'
      },


]
const Iqac_std_statisfy_data=[
    {
        'id':'1',
        'program':'Student Satisfaction Survey',
        'pdf':'/feedback_document_24-1.pdf'

    }
]


export {
    iqac,
    iqac_func,
    iqac_aim,
    iqac_strategy,
    iqac_feed,
    iqac_blocks,
    iqac_aqar,
    iqac_min,
    iqac_floater_menu,
    distinctiveness_data,
    Strategic_data,
    Iqac_std_statisfy_data,
    iqac_com
};